import './src/styles/tailwind.scss';
import 'swiper/scss';
import 'swiper/css/pagination';
import './src/styles/swiper-config.scss'
import './src/styles/convertor-config.scss'
import './src/styles/search-config.scss'
import { getCLS, getFID, getLCP } from 'web-vitals';

function sendToGoogleAnalytics({
    name, delta, value, id
}) {
    // Assumes the global `gtag()` function exists, see:
    // https://developers.google.com/analytics/devguides/collection/ga4
    gtag('event', `${name}`, {
    // Built-in params:
        value: delta, // Use `delta` so the value can be summed.
        // Custom params:
        metric_id: id, // Needed to aggregate events.
        metric_value: value, // Optional.
        metric_delta: delta, // Optional.

        debug_mode: process.env.NODE_ENV === 'development', // Optional.
    });
}

try {
    getCLS(sendToGoogleAnalytics);
    getFID(sendToGoogleAnalytics);
    getLCP(sendToGoogleAnalytics);
} catch (e) {
    console.error('Error in gtag', e);
}

export { wrapPageElement, wrapRootElement } from './gatsby-ssr';
